import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import SEO from '../components/SEO';
import AnimatedSection from '../components/AnimatedSection';
import PageHeader from '../components/PageHeader';
import TenagaPendidik from '../components/TenagaPendidik';

const GuruStaffPage = () => {
    const [staffList, setStaffList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const staffQuery = query(collection(db, 'staff'), orderBy('order', 'asc'));
                const staffSnapshot = await getDocs(staffQuery);

                const staffData = staffSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setStaffList(staffData);

            } catch (error) {
                console.error("Error fetching staff data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Pisahkan staf menjadi tenaga pendidik dan kependidikan
    const pendidik = staffList.filter(s => s.type && s.type.startsWith('pendidik'));
    const kependidikan = staffList.filter(s => s.type === 'kependidikan');

    return (
        <>
            <SEO
                title="Guru dan Staff - SMK Pariwisata Sumbangsih"
                description="Daftar Guru dan Staff pengajar di SMK Pariwisata Sumbangsih."
            />
            <PageHeader
                title="Guru dan Staff"
                subtitle="Tenaga Pendidik dan Kependidikan"
            />
            {loading ? (
                <section className="section">
                    <div className="container" style={{ textAlign: 'center' }}>Memuat konten...</div>
                </section>
            ) : (
                <AnimatedSection>
                    <TenagaPendidik pendidik={pendidik} kependidikan={kependidikan} loading={loading} />
                </AnimatedSection>
            )}
        </>
    );
};

export default GuruStaffPage;
